import req from "@/assets/js/axios"

//毕业展
export default {
    // 条件查询毕业展
    getFrontExhibitions: (params) => {
        return req.apiAxios('POST', '/exhibition/exhibitionController/getFrontExhibitions', params)
    },
    // 条件查询毕业展作品
    getOpusExhibitions: (params) => {
        return req.apiAxios('POST', '/opusExhibition/opusExhibitionController/getOpusExhibitions', params)
    },
    // 条件查询热门毕业展
    getHotExhibitions: (params) => {
        return req.apiAxios('POST', '/exhibition/exhibitionController/getHotExhibitions', params)
    },
     // 查询综合展会作品
     getOpusByCommonExhibition: (params) => {
        return req.apiAxios('POST', '/business/opus/BOpusController/getOpusByCommonExhibition', params)
    },
    // 条件查询热门学校
    getHotSchools: (params) => {
        return req.apiAxios('POST', '/school/schoolController/getHotSchools', params)
    },
    // 条件查询热门作品
    getHotOpus: (params) => {
        return req.apiAxios('POST', '/opus/OpusController/getHotOpus', params)
    },
    // 教师查询指导作品
    getTeacherStudentOpus: (params) => {
        return req.apiAxios('POST', '/business/opus/BOpusController/getOpus', params)
    },
    // 查询教师学校关联
    getTeacherStudents: (params) => {
        return req.apiAxios('POST', '/teacherStudent/teacherStudentController/getTeacherStudents', params)
    },
    // 查询vr
    getFrontVrs: (params) => {
        return req.apiAxios('POST', '/pavilion/pavilionController/getFrontPavilions', params)
    },
    // 获取vr配置的xml
    getXml: (params) => {
        return req.apiAxios('POST', '/business/pavilion/BPavilionController/tour', params)
    },
}
